export default "__VITE_ASSET__CuGiHAMi__"